<ng-container *ngIf="!isAuthenticated">
  <div class="container" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row" fxFlex="60%" fxFlex.xs="100%" fxFlex.sm="70%" fxLayoutAlign="center">
      <form
        name="form"
        (ngSubmit)="resetPassowrdForm.form.valid && resetPassword()"
        #resetPassowrdForm="ngForm"
        fxLayout="column"
        fxLayoutGap="35px"
        fxLayoutAlign="center center"
        autocomplete="off"
        novalidate
      >
        <div fxLayout="column" fxLayoutAlign="center">
          <div *ngIf="!emailSent">
            <h3>Reset password</h3>
            <p>To reset password, enter the email address associated with your account.</p>
            <div fxLayout="row wrap" fxLayoutAlign="center">
              <div fxFlex="60%" fxFlex.sm="70%" fxFlex.xs="90%">
                <mat-form-field appearance="outline" class="custom-form-field" fxFlex>
                  <input matInput type="email" #emailInput="ngModel" [(ngModel)]="email" name="emailInput" maxlength="250" required email />
                  <mat-label>Email</mat-label>
                </mat-form-field>
              </div>
              <div fxFlex="60%" fxFlex.sm="70%" fxFlex.xs="90%" *ngIf="resetPassowrdForm.submitted && emailInput.invalid">
                <div *ngIf="emailInput.errors.required" class="validation-error">Email is required</div>
                <div *ngIf="emailInput.errors.email" class="validation-error">Enter a valid email address</div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center">
              <button class="sign-in-btn" fxFlex="60%" fxFlex.sm="70%" fxFlex.xs="90%" mat-raised-button type="submit" color="primary">
                Send me instructions
              </button>
            </div>
          </div>
          <div *ngIf="emailSent" fxLayout="column">
            <h3>Email Sent</h3>
            <div fxLayout="row" fxLayoutAlign="soace-between">
              <p fxFlex>An email with instructions to reset your password has been sent to: {{ email }}.</p>
            </div>
          </div>
          <div fxLayout="row">
            <a href="/"> Home</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isAuthenticated">
  <div fxLayout="row">
    <div fxFlex="70" class="auth-container">
      <div fxLayout="row wrap" *ngIf="!emailSent">
        <h5 fxFlex="100">Reset password</h5>
        <p fxFlex="100">We'll send you an email with password reset instructions where you'll be able to change password.</p>
        <button mat-raised-button (click)="resetPassword()">Reset password</button>
      </div>
      <div fxLayout="row wrap" *ngIf="emailSent">
        <h5 fxFlex="100">Email Sent</h5>
        <p fxFlex="100" fxFlex>The email with further instructions has been sent to: {{ email }}.</p>
      </div>
    </div>
  </div>
</ng-container>
